import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import GrupoContext from '../../../context/grupo/grupoContext';
import AuthContext from '../../../context/autentication/authContext';
import SubGrupoContext from '../../../context/subgrupo/subgrupoContext';
import BotonLoading from "../../Buttons/BotonLoading"

import { Button } from "@material-ui/core";

import ShowResponse from "../ShowResponse"

////////// estilos ///////////////
const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "85vh",
    width: "98%",
    marginRight: "5em",
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  text: {
    padding: theme.spacing(2),
    textAlign: 'left',
    color: theme.palette.text.primary,
  },  
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  error: {
    color: "red"
  }
}));





export default function EditarSubGrupo({init, setOpen, grupo, alerta }) {
  ////////// estilos ///////////////
  const classes = useStyles();

  ///////////////// variables ////////////////

  const authContext = useContext(AuthContext);


  const grupoContext = useContext(GrupoContext);
  const { grupos, actualizarGrupo } = grupoContext;

  const subgrupoContext = useContext(SubGrupoContext);
  const { subGrupos, obtenerSubGrupos,actualizarSubGrupo } = subgrupoContext;
 
  const [state, setState] = useState(grupo);
  const [callback, setCallback] = useState({ msg: "", request: "", status:0});
  

  ///////////////////////////////////////////
  ////////// funciones ///////////////
  useEffect(() => {  
    
    // eslint-disable-next-line
  }, []);
  

 
  const onChange = (e) => {
    setCallback({cliente:"", estado:"", nombre:""})
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };
  const onSubmit = () => {
    // Validar que no haya campos vacios
    if (
      state.nombre.trim() === "" 
    
    ) {
      setCallback({
        ...callback,
        msg: "*todos los campos son obligatorios",
      });
    } else {
      setCallback({
        ...callback,
        msg: "",
      });      
      actualizarSubGrupo(state).then(value => setCallback(value))
    }
    init()
  }

  const close = () => {
      init()
      setOpen(false)
  }
  return (

          <Grid container direction="column" justify="center" alignItems="center" >
            
              <div noValidate autoComplete="off" onSubmit={onSubmit}>
                <Grid container direction="row" justify="center" alignItems="start" style={{width:"400px"}}>
                    <Grid item xs={12} >
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      id='nombre'
                      name="nombre"
                      label="Nombre"
                      value={state.nombre}
                      onChange={onChange}
                    />
                  </Grid>
                </Grid>
                {/* <Grid style={{ height: "3em" }} container direction="row" justify="center" alignItems="start" >
                  <ShowResponse callback={callback} />
                </Grid> */}
                <Grid container direction="row" justify="center" alignItems="start" >
                  <Grid item xs={8} >
                  {state.nombre ?
                      <BotonLoading texto={"Guardar"} disabled={false} load={alerta} onClick={onSubmit} close={close}/>
                      :
                      <BotonLoading texto={"Guardar"} disabled={true} load={alerta} onClick={onSubmit}/>
                    }
                  </Grid>
                </Grid>
              </div>
            
          </Grid>
      
  );
};